import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

async function getWidevineRobustness() {
  const robustnessLevels = [
    'SW_SECURE_CRYPTO', // Widevine L3
    'SW_SECURE_DECODE', // Widevine L3
    'HW_SECURE_CRYPTO', // Widevine L2
    'HW_SECURE_DECODE', // Widevine L1
    'HW_SECURE_ALL', // Widevine L1
  ];

  const videoTestConfig = [
    {
      videoCapabilities: [
        {
          contentType: 'video/mp4; codecs="avc1.42E01E"',
          robustness: 'SW_SECURE_DECODE',
        },
      ],
    },
  ];

  const audioTestConfig = [
    {
      audioCapabilities: [
        {
          contentType: 'audio/mp4;codecs="mp4a.40.2"',
          robustness: 'SW_SECURE_DECODE',
        },
      ],
    },
  ];

  let videoRobustness;
  let audioRobustness;

  for (let i = 0; i < robustnessLevels.length; i++) {
    const level = robustnessLevels[i];
    videoTestConfig[0].videoCapabilities[0].robustness = level;
    try {
      // eslint-disable-next-line no-await-in-loop
      await navigator.requestMediaKeySystemAccess(
        'com.widevine.alpha',
        videoTestConfig,
      );
      videoRobustness = level;
    } catch (err) {
      console.log(err);
    }
  }

  for (let j = 0; j < robustnessLevels.length; j++) {
    const level = robustnessLevels[j];
    audioTestConfig[0].audioCapabilities[0].robustness = level;
    try {
      // eslint-disable-next-line no-await-in-loop
      await navigator.requestMediaKeySystemAccess(
        'com.widevine.alpha',
        audioTestConfig,
      );
      audioRobustness = level;
    } catch (err) {
      console.log(err);
    }
  }

  return {
    videoRobustness,
    audioRobustness,
  };
}

@Component({
    selector: 'app-protected-image',
    templateUrl: './protected-image.component.html',
    styleUrls: ['./protected-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProtectedImageComponent implements OnInit {
  @Input() drmAuthorizationMessage = '';

  @ViewChild('videoPlayer', { static: true }) videoElementRef:
    | ElementRef
    | undefined;

  constructor(private platform: Platform) {}

  async ngOnInit() {
    // @ts-ignore
    const player = new shaka.Player(this.videoElementRef?.nativeElement);

    const config = await getWidevineRobustness();
    // alert(JSON.stringify(config));
    player.configure({
      drm: {
        servers: {
          'com.widevine.alpha':
            'https://drm-widevine-licensing.axprod.net/AcquireLicense',
        },
        advanced: {
          'com.widevine.alpha': config,
        },
      },
    });
    // }

    // player.getNetworkingEngine().registerRequestFilter((type, request) => {
    //   @ts-ignore
    // if (
    //   type === shaka.net.NetworkingEngine.RequestType.LICENSE &&
    //   this.drmAuthorizationMessage
    // ) {
    //   request.headers['X-AxDRM-Message'] = this.drmAuthorizationMessage;
    // }
    // });
    // player.load(`https://zalamo.com/gfx/drm/cenc/manifest.mpd`).then(() => {
    //   this.videoElementRef?.nativeElement.play();
    // });
  }
}
